import ConversationsDispatcher from '@/widget/application/conversations/ConversationsDispatcher';
import MessagesDispatcher from '@/widget/application/messages/MessagesDispatcher';
import { Operator } from '@/widget/domain/operator';
import ContactDispatcher from '@/widget/application/contact/ContactDispatcher';
import { ChatWidgetStore } from '@/widget/services/useChatWidgetStore';

type ContactInfoPayloadType = {
  contactId: string | number;
  companyId: string | number;
  conversationKeys: string[];
};

function setOnlineOperators(data: Operator[], store: ChatWidgetStore) {
  const { setOperators } = store.getState();
  setOperators(data, true);
}

function updateContactInfo({ contactId, companyId, conversationKeys }, store: ChatWidgetStore) {
  const {
    setContactRecognized,
    setContactInfo,
  } = store.getState();

  setContactInfo({
    contactId,
    companyId,
    conversationKeys,
  });
  setContactRecognized(true);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function cableService({ action, data } : { action: string, data: any }, connectedStore: ChatWidgetStore) {
  switch (action) {
    case 'contact_recognized':
      updateContactInfo(data as ContactInfoPayloadType, connectedStore);
      break;
    case 'set_online_operators':
      setOnlineOperators(data as Operator[], connectedStore);
      break;
    case 'conversations_found':
      ConversationsDispatcher.handleConversationsFound({ data, store: connectedStore });
      break;
    case 'messages_found':
      MessagesDispatcher.handleMessagesFound({ data, store: connectedStore });
      break;
    case 'message_received':
      MessagesDispatcher.messageReceived({ data, store: connectedStore });
      break;
    case 'contact_created':
      ContactDispatcher.setContact({ contactId: data, store: connectedStore });
      break;
    case 'new_message':
      MessagesDispatcher.receiveMessage({ data, store: connectedStore });
      break;
    default:
      break;
  }
}
